import { NavLink } from "react-router-dom";
import React, {Component, forwardRef} from 'react';
import {Col, Row, Table} from "reactstrap";
import Moment from "react-moment";
import 'moment/locale/fr';
import './Products.css'
import UpdateModalForm from "./modals/UpdateProductModal";
import {Activity, ChevronDown, ChevronUp, Copy, Edit2, Power, Shuffle, Star, Trash} from "react-feather";
import DeleteProductModal from "./modals/DeleteProductModal";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import {Badge, FormControl, OverlayTrigger, Spinner, Tooltip} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Logout from "./Logout";
import {ReactSortable} from "react-sortablejs";
import 'moment/locale/fr';
import InfiniteScroll from "react-infinite-scroll-component";
import debounce from 'lodash/debounce'
import { apiFetch, API, withMarket, getMarket } from "../services/api";

function getPosts() {

    return apiFetch(API.back + '/blog-posts', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getSearchProducts(headCategory, searchProduct) {
    let body = null

    // Lecture produits : ?lang=<market> route vers la table FR (products) ou ES (international_products).
    return apiFetch(withMarket(API.products + '/products?headCategory='+headCategory+'&keywords='+searchProduct.replaceAll(" ", "-")), {
        method: 'POST',
        body: body,
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getProducts(headCategory, lastEvaluatedKey) {
    let body = null
    if (lastEvaluatedKey) {
        body = JSON.stringify(lastEvaluatedKey)
    }

    // Lecture produits : ?lang=<market> route vers la table FR (products) ou ES (international_products).
    return apiFetch(withMarket(API.products + '/products?headCategory='+headCategory), {
        method: 'POST',
        body: body,
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getBrands() {
    return apiFetch(API.products + '/brands', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getMerchands() {

    return apiFetch(API.products + '/merchants', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getColors() {

    return apiFetch(API.products + '/colors', {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function getCategories(headCategory) {

    let parentCategory = headCategory.split("/products").pop()
    return apiFetch(API.products + '/categories?headCategory='+parentCategory, {
        method: 'GET',
    })
        .then(data => data.json())
        .catch( err =>
            console.log(err)
        )
}

function updateState(product, checked) {
    product.enable = checked
    product.language = getMarket()
    return apiFetch(API.products + '/product', {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(product)
    }).then()
        .catch( err =>
            console.log(err)
        )
}

function forceCompare(product) {
    product.language = getMarket()
    // langue dans l'URL (?lang=) ET dans le body, pour que le marché soit explicite.
    return apiFetch(withMarket(API.products + '/compare-product'), {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(product)
    }).then(() => document.location.reload())
        .catch( err =>
            document.location.reload()
        )
}

// Vignette de la liste (refonte 10/2026) : image du meilleur coloris, sinon du coloris de même
// référence, sinon du premier coloris — l'image du meilleur coloris est souvent vide côté API.
const productThumb = (product) => {
    const bd = product.bestDeclinations || {};
    if (bd.firstImg) return bd.firstImg;
    const decls = product.declinations || [];
    const same = decls.find((d) => d.reference && d.reference === bd.reference && d.firstImg);
    if (same) return same.firstImg;
    const first = decls.find((d) => d.firstImg);
    return first ? first.firstImg : null;
};

export class ProductsList extends Component{
    constructor(props) {
        super(props);
        this.state = {
            products: null,
            comparing: {},
            errors: null,
            loading: true,
            isOpen: false,
            isDelete: false,
            lastEvaluatedKey: null,
            hasMore: true,
            selectedProduct: {
                name : "",
                description: "",
                gender: "",
                price: 0.0,
                brand: "",
                order: 0,
                categories: [],
                shopType: [],
                declinations: [],
                metaTitle:"",
                metaDescription:"",
                showProduct: true,
            },
            searchProductData: "",
            availableBrands: null,
            availablePosts: null,
            availableMerchands: null,
            availableColors: null,
            availableTypes: ["athletisme", "running", "trail"],
            availableCategories: null,
            initialProducts: null,
            headCategory: this.props.location.pathname,
            dragId: null,
        }
        this.filterList = this.filterList.bind(this);
        this.sortList = this.sortList.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.fetchMoreProducts = this.fetchMoreProducts.bind(this)
    }

    async componentDidMount() {
        if (window.location.search && window.location.search.includes("?slug=")){
            let lowercasedValue = window.location.search.replace("?slug=", "")
            lowercasedValue = lowercasedValue.replaceAll("%20", " ")
            await getSearchProducts(this.props.location.pathname, lowercasedValue).then((data) => {
                this.setState({searchProductData: lowercasedValue, initialProducts: data.products, loading: false, products: data.products, lastEvaluatedKey: null, hasMoreValue: false});
            })
        } else {
            await getProducts(this.state.headCategory).then(data => {
                this.setState({ initialProducts: data.products, products: data.products, lastEvaluatedKey: data.lastEvaluatedKey, hasMoreValue: data.lastEvaluatedKey ? true : false, errors : "", loading: false })
            }).catch(err =>{
                //localStorage.removeItem('token');
                //window.location.href="/";
                this.setState({errors: "error while getting products"})
                }
            );
        }
        
        await getBrands().then(data => {
            this.setState({ availableBrands: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting brands"})
        );
        await getMerchands().then(data => {
            this.setState({ availableMerchands: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting merchands"})
        );
        await getColors().then(data => {
            this.setState({ availableColors: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting colors"})
        );
        await getCategories(this.state.headCategory).then(data => {
            this.setState({ availableCategories: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting categories"})
        );
        await getPosts().then(data => {
            this.setState({ availablePosts: data, errors : "" })
        }).catch(err =>
            this.setState({errors: "error while getting posts"})
        );
    };

    async filterList(keyword){
        const excludeColumns = ["id", "color", "posts"];
        const lowercasedValue = keyword.toLowerCase().trim();

        if(lowercasedValue.length > 5){
            this.props.history.push(`${window.location.pathname}?slug=${lowercasedValue}`);

            this.setState({initialProducts: null, products: null, loading: true, lastEvaluatedKey: null, hasMoreValue: false});
            await getSearchProducts(this.props.location.pathname, lowercasedValue).then((data) => {
                this.setState({initialProducts: data.products, loading: false, products: data.products, lastEvaluatedKey: null, hasMoreValue: false});
            })
        } else if (lowercasedValue == ""){
            await getProducts(this.state.headCategory).then(data => {
                this.setState({ initialProducts: data.products, products: data.products, lastEvaluatedKey: data.lastEvaluatedKey, hasMoreValue: data.lastEvaluatedKey ? true : false, errors : "", loading: false })
            }).catch(err =>{
                //localStorage.removeItem('token');
                //window.location.href="/";
                this.setState({errors: "error while getting products"})
                }
            );
        }
    }

    searchWithDebounce = debounce(this.filterList, 500)

    async fetchMoreProducts(headCategory, lastEvaluatedKey){
        console.log(lastEvaluatedKey)
        await getProducts(headCategory, lastEvaluatedKey).then(data => (  
            this.setState({ products: [...this.state.products, ...data.products ], lastEvaluatedKey: data.lastEvaluatedKey, hasMoreValue: data.lastEvaluatedKey ? true : false, errors : "", loading: false })
        )).catch(err =>{
            //localStorage.removeItem('token');
            //window.location.href="/";
            this.setState({errors: "error while getting products"})
            }
        );
    }

    sortList(type){
        let sortedList = this.state.products;
        switch (type) {
            case "asc":
                sortedList = sortedList.sort(function(a,b){
                    return a.name.localeCompare(b.name);
                })

                this.setState({products: sortedList});
                break;
            case "desc":
                sortedList = sortedList = sortedList.sort(function(a,b){
                    return b.name.localeCompare(a.name);
                })
                this.setState({products: sortedList});
                break;

            default:
                this.setState({products: sortedList});
        }
    }

    closeModal = () => this.setState({ isOpen: false, selectedProduct: {
            name : "",
            description: "",
            gender: "",
            price: 0.0,
            brand: "",
            categories: [],
            declinations: [],
            metaTitle:"",
            metaDescription:"",
        } });

    handleDrag = (ev) => {
        this.setState({dragId : ev.currentTarget.id});
    };

    handleDrop = (list) => {
        let now = new Date()
        now.setHours(now.getHours()-2)
        console.log(now)
        let i = 0
        const newBoxState = list.map((product, index) => {
            product.order = index

            /*if (product && product.name && (product.name.includes("chaussure") || product.name.includes("Chaussure"))){
                fetch('https://backapi.therunningcollective.fr/api/protected/'+"new-product", {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(product)
                })
                    .then(data => data.json())
                    .catch( err =>
                        console.log(err)
                    )
            }

            /*if (product.categories){
                product.categories = product.categories.filter(item => item !== "Black Friday")
            } else {
                console.log(product)
            }*/

            /*let toPost = false
            if (product.categories && product.enable && product.bestDeclinations.bestRetailer.amount > 29){
                if (product.categories.indexOf("Black Friday") > -1) {
                    //In the array!
                } else {
                    //Not in the array
                    let cat = product.categories.concat(['Black Friday'])
                const uniqueNames = cat.filter((val,id,array) => array.indexOf(val) == id);

                product.categories = uniqueNames
                toPost = true
                }
                

            }
            if (product.enable == false && product.brand == "Mizuno") {
                fetch('https://backapi.therunningcollective.fr/api/protected/'+"new-product", {
                    method: 'DELETE',
                    headers: {
                        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(product)
                })
                    .then(data => data.json())
                    .catch( err =>
                        console.log(err)
                    )
            }*/

            /*let toPost = false
            let declinations = []
            product.declinations.map(d => {
                let newD = d
                if (d.price == 0) {
                    d.analysedRetailers && d.analysedRetailers.map(r => {
                        if(r.retailerName == "HokaOneOne"){
                            newD.price = r.price
                            toPost = true
                        }
                    })
                }
                declinations.push(newD)
            })
            product.declinations = declinations

            if (toPost){
                console.log(product.name)
                fetch('https://backapi.therunningcollective.fr/api/protected/'+"new-product", {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(product)
                })
                    .then(data => data.json())
                    .catch( err =>
                        console.log(err)
                    )
            }*/
            

            return product;
        });



        /*fetch('https://back-products-api.therunningcollective.fr/product-order', {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${JSON.parse(localStorage.getItem('token')).token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(newBoxState)
        }).then(this.props.closeModal)
            .catch( err =>
                console.log(err)
            )*/

        this.setState({products : newBoxState});

    };

    renderTooltip = (sizes) => (
        <Tooltip id="button-tooltip" >
            {sizes ?
                sizes.map((size) => {return (<div key={size}>{size}</div>)})
                : "Indisponible" }
        </Tooltip>
    );
    renderTooltipColor = (declinations) => (
        <Tooltip id="button-tooltip">
            {declinations ?
                declinations.map((declination) => {return (<div key={declination.reference}>{declination.color}</div>)})
                : "Indisponible" }
        </Tooltip>
    );
    renderTooltipBestDeclination = (bestDeclinations) => (
        <Tooltip id="button-tooltip" >
            {bestDeclinations ?
                 <div key={bestDeclinations.reference}>
                     <div>Référence : {bestDeclinations.reference}</div>
                     <div>Coloris : {bestDeclinations.color}</div>
                     <div>
                         <img className="imgToDisplay" alt="Couverture actuelle" src={bestDeclinations.firstImg}/>
                     </div>
                     <br/>
                 </div>
                : "Indisponible" }
        </Tooltip>
    );

    // Comparaison forcée : spinner sur la ligne jusqu'au rechargement de la page (fait par forceCompare),
    // et un second clic pendant l'appel est ignoré.
    startCompare = (product) => {
        const key = product.id || product.shortURL || product.name;
        if (this.state.comparing[key]) return;
        this.setState({comparing: {...this.state.comparing, [key]: true}});
        forceCompare(product);
    };

    isStartingCompare = (product) => !!this.state.comparing[product.id || product.shortURL || product.name];

    render(){
        return(
            <div className="products-list">
                {/* Catégories en pastilles (refonte 10/2026) : liens vers les listes existantes */}
                <div className="trc-chips">
                    {[["shoes","Chaussures"],["spikes","Pointes"],["apparel","Vêtements"],["accessories","Accessoires"],["nutrition","Diététique"],["electronic","Électronique"],["vouchers","Cartes cadeau"],["triathlon","Triathlon"]].map(([hc, label]) => (
                        <NavLink key={hc} to={"/products/" + hc} className="trc-chip" activeClassName="on">{label}</NavLink>
                    ))}
                </div>
                <Row className="align-items-center">
                    <Col sm={8} className="products-buttons">
                        <Button className="add-product-button " variant="secondary" type="submit"onClick={(e) => this.setState({isOpen : true})}>Ajouter un produit</Button>
                    </Col>
                    <Col sm={4}>
                        <FormControl type="text" placeholder="Rechercher par nom..." onChange={(e) => {this.searchWithDebounce(e.target.value); this.setState({searchProductData : e.target.value})}} value={this.state.searchProductData}/>
                    </Col>
                </Row>
                {this.state.products == null ? <p> Chargement ...</p> :

                <div>
                    <Row>
                        <Col sm={8} className="products-buttons">
                            <span className="trc-count">Nombre de produits : {this.state.products.length}</span>
                        </Col>
                        
                    </Row>
                    <div className="trc-table-card">
                    <Table responsive className="trc-products-table">

                        <tbody>

                        

                        {(this.state.loading !== true)
                            ?

                            <InfiniteScroll
                                scrollThreshold="50%"
                                style={{overflow: "inherit"}}
                                dataLength={this.state.products.length}
                                next={() => this.fetchMoreProducts(this.state.headCategory, this.state.lastEvaluatedKey)}
                                hasMore={this.state.hasMoreValue}
                                loader={<div style={{textAlign: 'center'}}>
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden"></span>
                                            </Spinner>
                                        </div>}
                            >
                                <tr
                                        key={0}
                                        id="begin"
                                        className="trc-head-row"
                                        style={{textAlign: 'center', fontWeight: 800}}
                                    >
                                        <td>Prioritaire</td>
                                        <td>Actif</td>
                                        <td>Nom</td>
                                        <td>Marque</td>
                                        <td>Sexe</td>
                                        <td>Prix Public</td>
                                        <td>Couleurs</td>
                                        <td>Meilleur revendeur</td>
                                        <td>Meilleur prix</td>
                                        <td>Réduction</td>
                                        <td>Tailles dispos</td>
                                        <td>Poids</td>
                                        <td>Drop</td>
                                        <td>Stack</td>
                                        <td>Max Kms</td>
                                        <td>Intégré au blog ?</td>
                                        <td>Texte enrichi ?</td>
                                        <td>Heure de comparaison</td>
                                        <td>Afficher sur le site</td>
                                        <td>Forcer la comparaison</td>
                                        <td>Modifier</td>
                                        <td>Supprimer</td>
                                    </tr>
                                {!this.state.loading ? this.state.products.map((product) => (
                                    <tr
                                        key={product.order}
                                        id={product.id}
                                        style={{textAlign: 'center'}}
                                    >
                                        <td>
                                        {product.priorityProduct ?
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="button-tooltip">Produit prioritaire</Tooltip>}
                                            >
                                                <Star/>
                                            </OverlayTrigger>
                                             : null}</td>
                                        <td>{product.active === true ? <Badge pill variant="success">
                                            Actif
                                        </Badge> : <Badge pill variant="danger">
                                            Inactif
                                        </Badge>}</td>
                                        <td>
                                            <div className="trc-product-cell">
                                                {productThumb(product)
                                                    ? <img className="trc-thumb" alt="" src={productThumb(product)} loading="lazy"/>
                                                    : <span className="trc-thumb"/>}
                                                <span>{product.name}</span>
                                            </div>
                                        </td>
                                        <td>{product.brand}</td>
                                        <td>{product.gender}</td>
                                        <td>{product.bestDeclinations.price}€</td>

                                        <OverlayTrigger
                                            placement="top"
                                            overlay={this.renderTooltipColor(product.declinations)}
                                        >
                                            <td>{product.declinations ? product.declinations.length : 0 }</td>
                                        </OverlayTrigger>
                                        <td>{product.bestDeclinations.bestRetailer.retailerName}</td>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={this.renderTooltipBestDeclination(product.bestDeclinations)}
                                        >
                                            <td>{product.bestDeclinations.bestRetailer.price}€</td>
                                        </OverlayTrigger>
                                        <td>{Math.round((product.bestDeclinations.price - product.bestDeclinations.bestRetailer.price) / product.bestDeclinations.price * 100)}%</td>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={this.renderTooltip(product.bestDeclinations.bestRetailer.sizes)}
                                        >
                                            <td>{product.bestDeclinations.bestRetailer.sizes ? product.bestDeclinations.bestRetailer.sizes.length : 0 }</td>
                                        </OverlayTrigger>
                                        <td>{product.weigh != "" ? product.weigh : ""}</td>
                                        <td>{product.drop != "" ? product.drop : ""}</td>
                                        <td>{product.stack != "" ? product.stack : ""}</td>
                                        <td>{product.maxkm != "" ? product.maxkm : ""}</td>
                                        <td>{product.blogIntegratedShortURL != "" ? "Article intégré" : ""}</td>
                                        <td>{product.enrichedText != "" ? "Texte intégré" : ""}</td>
                                        <td><Moment to={product.updatedDate} locale="fr">{Date.now()}</Moment></td>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="button-tooltip">Afficher le produit sur le site</Tooltip>}
                                        >
                                            <td><BootstrapSwitchButton
                                                checked={product.enable}
                                                onlabel='oui'
                                                onstyle='success'
                                                offlabel='non'
                                                offstyle='danger'
                                                size='xs'
                                                onChange={(checked: boolean) => {
                                                    updateState(product, checked)
                                                }}
                                            /></td>
                                        </OverlayTrigger>

                                        {product.isComparing
                                        ?
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="button-tooltip">Comparaison du produit en cours</Tooltip>}
                                            >
                                                <td className="table-action" style={{cursor: 'not-allowed', opacity: '0.33'}}>
                                                    {this.isStartingCompare(product) ? <Spinner animation="border" size="sm" role="status" className="trc-compare-spinner"><span className="visually-hidden"></span></Spinner> : <Activity className="align-middle mr-1" size={18} onClick={(e) => this.startCompare(product)}/>}
                                                </td>
                                            </OverlayTrigger>
                                        :
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="button-tooltip">Forcer la comparaison du produit</Tooltip>}
                                            >
                                                <td className="table-action" style={{cursor: 'pointer'}}>
                                                    {this.isStartingCompare(product) ? <Spinner animation="border" size="sm" role="status" className="trc-compare-spinner"><span className="visually-hidden"></span></Spinner> : <Shuffle className="align-middle mr-1" size={18} onClick={(e) => this.startCompare(product)}/>}
                                                </td>
                                            </OverlayTrigger>
                                            }
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="button-tooltip">Modifier le produit</Tooltip>}
                                        >
                                            <td className="table-action" style={{cursor: 'pointer'}}>
                                                <Edit2 className="align-middle mr-1" size={18} onClick={(e) => this.setState({isOpen : true, selectedProduct : product})}/>
                                            </td>
                                        </OverlayTrigger>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="button-tooltip">Supprimer le produit</Tooltip>}
                                        >
                                            <td className="table-action" style={{cursor: 'pointer'}}>
                                                <Trash className="align-middle" size={18} onClick={(e) => this.setState({isDelete : true, selectedProduct : product})} />
                                            </td>
                                        </OverlayTrigger>



                                    </tr>
                                )) : null }
                            </InfiniteScroll>
                        :
                        null }
                        </tbody>
                    </Table>
                    </div>
                </div>
                }
                { this.state.isOpen ?
                    <UpdateModalForm
                        closeModal={this.closeModal}
                        isOpen={this.state.isOpen}
                        handleSubmit={this.handleSubmit}
                        selectedProduct={this.state.selectedProduct}
                        availableBrands={this.state.availableBrands}
                        availableMerchands={this.state.availableMerchands}
                        availableColors={this.state.availableColors}
                        availableCategories={this.state.availableCategories}
                        availableTypes={this.state.availableTypes}
                        availablePosts={this.state.availablePosts}
                        headCategory={this.state.headCategory}
                        order={this.state.selectedProduct.order !== 0 ? this.state.selectedProduct.order : (this.state.products ? this.state.products.length+1 : 1)}
                    />
                    :
                    null
                }
                { this.state.isDelete ?
                    <DeleteProductModal
                        closeModal={this.closeModal}
                        isOpen={this.state.isDelete}
                        handleSubmit={this.handleSubmit}
                        selectedItem={this.state.selectedProduct}
                    />
                    :
                    null
                }
            </div>
        );
    }
}